import { ColumnFieldType } from '../../enums/index';
import { ColumnFieldTypeObject } from '../ColumnFieldTypeObject';
import { ActionIconDto } from './ActionIconDto';

export class ColumnActionIconsDto extends ColumnFieldTypeObject {
  ActionIcons: ActionIconDto[];

  constructor(init?: Partial<ColumnActionIconsDto>) {
    super();
    this.FieldType = ColumnFieldType.ActionIcons;
    Object.assign(this, init);
  }
}
